import Bank1 from '../../../assests/images/cyber.jpg';
import Bank2 from '../../../assests/images/custsup.png';
import Bank3 from '../../../assests/images/Data.jpg';

export const bankData = [
  {
    title: "Guaranteed Security",
    description: "Bank with peace of mind: Our app ensures ironclad security for your financial transactions.",
    urls: Bank1,
  },
  {
    title: " ",
    description: " ",
    urls: Bank2,
  },
  {
    title: "Data Protection",
    description: "Ensuring the security and confidentiality of your sensitive information.",
    urls: Bank3,
  },
];